// extracted by css-extract-rspack-plugin
export default {"pinnedNav":"PinnedViewsNav-module__pinnedNav__M_meK","divider":"PinnedViewsNav-module__divider__YYZsC","dividerCollapsible":"PinnedViewsNav-module__dividerCollapsible__m9Jzd"};